module.exports = __webpack_public_path__ + "static/media/G3.582f141d.png";